import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
    // console.log(store.getters.checkPermission("position_type-create"));

const routes = [{
        path: '/documents/:name',
        component: () =>
            import ('@/views/Document'),
        visible: true, //store.getters.checkPermission("templates-index")
    },
    {
        path: '/404',
        component: () =>
            import ('@/views/layouts/404'),
        visible: true, //store.getters.checkPermission("templates-index")
    },
    {
        path: '/403',
        component: () =>
            import ('@/views/layouts/403'),
    },
    {
        path: '*',
        redirect: '/404',
    },
]

const router = new VueRouter({
    mode: 'hash',
    // mode: 'history',
    base: process.env.BASE_URL,
    routes
})


//--------------------------------------------------------------------------------------
router.beforeEach((to, from, next) => {
    // var access_token = Cookies.get('access_token');
    // if (!access_token) {
    //     setTimeout(() => {
    //         access_token = Cookies.get('access_token');
    //     }, 100);
    // }
    // if (!access_token && to.fullPath != '/login') {
    //     store.dispatch('setRedirectUrl', to.fullPath);
    //     next({
    //         path: '/login',
    //     })
    // } else
    next()
})
export default router